
import {
    headerConfigKeyName,
  } from './app.config';
  
  export function getHeaderConfig() {
    return localStorage.getItem(headerConfigKeyName)
      ? JSON.parse(localStorage.getItem(headerConfigKeyName))
      : {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Accept": 'application/json',
          "Accept-Language":'ar'
        },
      };
  };
  
  export function clearAuthInfo() {
    localStorage.removeItem(headerConfigKeyName);
  };
  
  export function setHeaderConfig(header) {
    localStorage.setItem(headerConfigKeyName, JSON.stringify(header));
  };
  
  export function makeFilterString(filter_obj) {
    var filterString = '?';
    Object.keys(filter_obj).map(function (key) {
      if (filter_obj[key]) {
        filterString += key + '=' + filter_obj[key] + '&';
      }else{
        return false
      }
    });
    return filterString;
  }